const APP_BASENAME = (process.env.REACT_APP_BASENAME || "/").replace(/\/$/, "");

export function withAppBase(path: string): string {
  if (/^[a-z]+:/i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return APP_BASENAME && APP_BASENAME !== "/"
    ? `${APP_BASENAME}${normalizedPath}`
    : normalizedPath;
}
